import { CloseButton } from "@/components/CloseButton/CloseButton";
import s from "./style.module.scss";
import { UIButton } from "@/components/UIButton/UIButton";
import clsx from "clsx";
import {
  currentOrderAtom,
  sendToArbitrage,
} from "@/core/reatom/state/orders/orders";
import { useAction, useAtom } from "@reatom/npm-react";
import { useState } from "react";

interface CategoriesProps {
  closeModal: () => void;
}

export const Arbitrage = ({ closeModal }: CategoriesProps) => {
  const [currentOrder] = useAtom(currentOrderAtom);
  const handleArbitrage = useAction(sendToArbitrage);
  const [value, setValue] = useState("");
  return (
    <div className={s.wrapper}>
      <div className={s.line}></div>
      <CloseButton onClose={closeModal} />
      <p className={s.title}>Обращение в арбитраж</p>
      <p className={s.subTitle}>
        Пожалуйста, укажите, по какой именно причине вы хотите обратиться в
        Арбитраж.
      </p>
      <div className={s.inputContainer}>
        <label className={s.inputLabel}>Обращение</label>
        <textarea
          className={s.input}
          placeholder="Напишите здесь причину обращения в Арбитраж"
          value={value}
          onChange={(e) => setValue(e.target.value)}
        />
        <p className={s.help}>Не более 500 символов</p>
      </div>
      <div className={s.buttons}>
        <UIButton
          fontType="primary-2"
          className={s.button}
          onClick={() =>
            currentOrder?.id &&
            value.trim() &&
            handleArbitrage(currentOrder?.id, value).finally(() => closeModal())
          }
        >
          Начать Арбитраж
        </UIButton>
        <UIButton
          fontType="primary-2"
          color="inverted"
          className={clsx(s.button, s.closeButton)}
          onClick={closeModal}
        >
          Продолжить сотрудничество
        </UIButton>
      </div>
    </div>
  );
};
